module.exports = __webpack_public_path__ + "static/media/Bear612a_1c.67aaadcc.svg";